<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        {{ markType }}记录
      </div>
    </div>
    <div class="ml20 mt20 f18 blue">
      <i class="el-icon-back cursor" @click="$router.back()"> 返回</i>
    </div>
    <!-- <unitList @select="getUnit" @getFirst='getOne'></unitList> -->
    <div class="flex center ml20">
      <el-form ref="form" v-model="form" :rules="rules" class="mt20" style="width: 100%">
        <h2 class="center">社会单位灭火和应急疏散预案{{ markType }}记录</h2>

        <el-row :gutter="24" class="mt20">
          <el-col :span="24">
            <el-row>
              <div class="center" style="font-size: 20px; line-height: 50px">
                <div class="center" style="width: 70%">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div>
                    <span style="width: 80px; display: inline-block"><el-input size="small" v-model="form.year"></el-input></span>
                    年
                    <span style="width: 80px; display: inline-block"><el-input v-model="form.month" size="small"></el-input></span>
                    月
                    <span style="width: 80px; display: inline-block"><el-input v-model="form.day" size="small"></el-input></span>
                    日
                    <span style="width: 80px; display: inline-block"><el-input v-model="form.time" size="small"></el-input></span>
                    时，我公司按 {{ form.drillName }} {{ $route.query.page == 0 ? "组织了一次员工消防演练" : "进行了一次灭火行动" }}，具体情况记录如下：
                  </div>
                </div>
              </div>
            </el-row>

            <el-row :gutter="20">
              <div v-for="(item, index) in muban" :key="index">
                <el-row class="center">
                  <el-col :span="16" class="mt20">
                    <h2>{{ item.title }}</h2>
                  </el-col>
                </el-row>
                <el-row class="center mt10" v-for="(it, ind) in item.child">
                  <el-col :span="16">
                    <el-form-item v-if="index == 0 || index == 2" :prop="it.formName" :label="`（${ind + 1}）` + it.subTitle">
                      <el-input v-model="form[it.formName]" type="textarea" :placeholder="it.subDesc ? '主要包括:' + it.subDesc : ''" :rows="2"></el-input>

                      <div v-if="it.delable" class="mt10" style="float: right">
                        <el-button type="danger" @click="delItem(index, ind)" size="small">—</el-button>
                      </div>
                    </el-form-item>

                    <el-form-item v-if="index == 1" :prop="item.formName[it.formName]" :label="`（${ind + 1}）` + it.subTitle">
                      <el-input v-model="form[item.formName][it.formName]" type="textarea" :rows="2"></el-input>
                      <div class="mt10" v-if="index == 1" style="line-height: 20px; font-weight: 900">主要包括:{{ it.subDesc }}</div>

                      <div v-if="it.delable" class="mt10" style="float: right">
                        <el-button type="danger" @click="delItem(index, ind)" size="small">—</el-button>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- <el-row class="center">
                <el-col :span="16" class="mt20">
                  <h2>二、应急组织机构{{markType}}人员及主要职责记录</h2>
                </el-col>
              </el-row>

              <el-row class="center">
                <el-col :span="16" class="mt20">
                  <h2>三、火灾情况记录</h2>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item prop="zhuyhao_qihuo " label="（1）起火时间段：">
                    <el-input
                      v-model="form.zhuyhao_qihuo"
                      type="textarea"
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item prop="qihuo_fangxiang" label="（2）起火位置：">
                    <el-input
                      v-model="form.qihuo_fangxiang"
                      type="textarea"
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item prop="weihai_houguo " label="（3）起火物品：">
                    <el-input
                      v-model="form.weihai_houguo"
                      type="textarea"
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item
                    prop="qufen_qijian"
                    label="（4）燃烧范围及火势蔓延情况"
                  >
                    <el-input
                      v-model="form.qufen_qijian"
                      type="textarea"
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item
                    prop="qufen_qijian"
                    label="（5）消防安全重点部位："
                  >
                    <el-input
                      v-model="form.qufen_qijian"
                      type="textarea"
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col> </el-row
              ><el-row class="center mt20">
                <el-col :span="16">
                  <el-form-item
                    prop="qufen_qijian"
                    label="（6）火灾造成的危害和影响："
                  >
                    <el-input
                      v-model="form.qufen_qijian"
                      type="textarea"
                      :rows="3"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <el-row class="center">
                <el-col :span="16" class="mt20">
                  <h2>四、火灾报警、接警处置程记录</h2>
                </el-col>
              </el-row>
              <el-row class="center">
                <el-col :span="16">
                  <el-form-item prop="patrol.c_point_addr">
                    <!-- <p>
                        （1）
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.year1"
                          ></el-input
                        ></span>
                        年
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.month1"
                          ></el-input
                        ></span>
                        月
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.day1"
                          ></el-input
                        ></span>
                        日
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.time1"
                          ></el-input
                        ></span>
                        时，员工
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.name1"
                          ></el-input
                        ></span>
                        发现
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.location1"
                          ></el-input
                        ></span>
                        ，
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.thing1"
                          ></el-input
                        ></span>
                        起火，立即通知消防控制室值班人员
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.name2"
                          ></el-input
                        ></span>
                        ，并使用附近灭火器扑救初期火灾。
                      </p>
                      <p>
                        （2）消防控制室值班人员
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.name3"
                          ></el-input
                        ></span>
                        接到火灾报警后，立即响应火灾应急处置程序：
                      </p>
                      <p class="ml20">
                        1）立即拨打“119”火警电话，上报火情相关内容：①着火单位；②着火部位；③着火物质；④有无人员被困；⑤单位具体位置；⑥报警电话号码；⑦报警人姓名。
                      </p>
                      <p class="ml20">
                        2）另一位消防控制室值班人员
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.name4"
                          ></el-input
                        ></span>
                        同时将所有自动消防系统联动控制装置调整到“自动状态”，并利用多线手动控制盘启动重要消防设施
                      </p>
                      <p class="ml20">
                        3）值班人员
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.name5"
                          ></el-input
                        ></span>
                        立即通知本单位负责人
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.name6"
                          ></el-input
                        ></span>
                        。并安排员工
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.name7"
                          ></el-input
                        ></span>
                        到公司大门外的主要道口，迎接并引导消防车快捷到达火灾现场。
                      </p>
                      <p>
                        （3）单位负责人
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.name6"
                          ></el-input
                        ></span>
                        接到火情报警后，立即启动相关区域应急预案，一键派发预案内容至相关员工手机端，并迅速组织指挥初期火灾的扑救和人员疏散工作，安排力量做好警戒工作。
                      </p> -->
                    <el-input class="mt10" type="textarea" v-model="form.alarmRecord" style="line-height:30px" rows="8"> </el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row class="center">
                <el-col :span="16" class="mt20">
                  <h2>五、灭火及应急疏散{{ markType }}过程记录</h2>
                </el-col>
              </el-row>

              <el-row class="center">
                <el-col :span="16">
                  <el-form-item prop="patrol.c_point_addr">
                    <!-- <div class="duty mt10">
                      <p>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;火情发生后，我公司应急预案及时启动，各行动小组和志愿消防队迅速集结，按照职责分工，进入相应位置开展灭火救援行动。
                      </p>
                      <p>
                        （1）员工<span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.alarmRecord.name1"
                          ></el-input
                        ></span>
                        与起火部位现场员工
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.fireRecord.name10"
                          ></el-input></span
                        >立即形成灭火第一战斗力量，第一时间利用现场灭火器进行灭火；灭火行动组队员
                        <span class="inputBig"
                          ><el-input
                            size="small"
                            v-if="
                              !(
                                form.personRecord.miehuoName ===
                                'personRecordDeleteFlag'
                              )
                            "
                            v-model="form.personRecord.miehuoName"
                          ></el-input
                        >
                        <el-input disabled v-else></el-input>
                        </span>
                        在
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.fireRecord.minute"
                          ></el-input
                        ></span>
                        分钟内陆续到达火场，利用消防设施、器材扑救火灾，于
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.fireRecord.hour1"
                          ></el-input
                        ></span>
                        时
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.fireRecord.minute1"
                          ></el-input></span
                        >分，将大火扑灭。
                      </p>

                      <p>
                        （2）疏散引导组
                        <span class="inputBig"
                          ><el-input
                            size="small"
                                  v-if="
                              !(
                                form.personRecord.shusanName ===
                                'personRecordDeleteFlag'
                              )
                            "
                            v-model="form.personRecord.shusanName"
                          ></el-input>
                                    <el-input disabled v-else size="small"></el-input>
                          
                          
                          </span
                        >按分工组织引导现场人员进行疏散；于
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.fireRecord.hour2"
                          ></el-input
                        ></span>
                        时
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.fireRecord.minute2"
                          ></el-input
                        ></span>
                        分，起火建筑内所有人员均被疏散至安全区域。
                      </p>
                      <p>
                        （3）安全救护组
                        <span class="inputBig"
                          ><el-input
                           v-if="
                              !(
                                form.personRecord.jiuhuName ===
                                'personRecordDeleteFlag'
                              )
                            "
                            size="small"
                            v-model="form.personRecord.jiuhuName"
                          ></el-input>
                                    <el-input disabled v-else size="small"></el-input>
                          
                          </span
                        >负责协助抢救、护送受伤人员。
                      </p>
                      <p>
                        （4）现场警戒组<span class="inputBig"
                          ><el-input
                            size="small"
                            v-model="form.personRecord.jingjieName"
                              v-if="
                              !(
                                form.personRecord.jingjieName ===
                                'personRecordDeleteFlag'
                              )
                            "
                          ></el-input
                        >
                                    <el-input disabled v-else size="small"></el-input>
                        
                        </span>
                        在起火建筑出入口处设置警戒，拦阻无关人员进入火场，并维持现场秩序。
                      </p>
                      <p>
                        （5）通信联络组<span class="inputBig"
                          ><el-input
                            size="small"
                            v-model="form.personRecord.lianluoName"
                             v-if="
                              !(
                                form.personRecord.lianluoName ===
                                'personRecordDeleteFlag'
                              )
                            "
                          ></el-input
                        >
                                    <el-input disabled v-else size="small"></el-input>
                        
                        </span>
                        及时联系相关救援力量和应急人员参与救援工作。
                      </p>
                    </div> -->

                    <el-input class="mt10" type="textarea" v-model="form.fireRecord" style="line-height:30px" rows="8"> </el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row class="center">
                <el-col :span="16" class="mt20">
                  <h2>六、灭火和应急疏散图</h2>
                </el-col>
              </el-row>

              <el-row class="center">
                <el-col :span="16">
                  <el-form-item prop="miehuoImage" label="上传图片(最多可上传2张)">
                    <el-col>
                      <el-upload action="#" class="uploadSmall" :http-request="up1" list-type="picture-card" :file-list="fileList1" :limit="2">
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="file" style="background: red" slot-scope="{ file }">
                          <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                          <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                              <i class="el-icon-zoom-in"></i>
                            </span>

                            <span class="el-upload-list__item-delete" @click="handleRemove(file, 'nowImage1')">
                              <i class="el-icon-delete"></i>
                            </span>
                          </span>
                        </div>
                      </el-upload>
                    </el-col>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row class="center">
                <el-col :span="16" class="mt20">
                  <h2>七、{{ markType }}总结</h2>
                </el-col>
              </el-row>

              <el-row class="center">
                <el-col :span="16">
                  <el-form-item prop="patrol.c_point_addr">
                    <!-- <div class="duty mt10">
                      <p>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ markType }}结束后，由
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.exerciseSummaryPosition"
                          ></el-input
                        ></span>
                        <span class="inputSmall"
                          ><el-input
                            size="small"
                            v-model="form.exerciseSummaryName"
                          ></el-input
                        ></span>
                        （姓名）组织相关人员全面总结本次消防{{
                          markType
                        }}情况，提出改进意见，并形成如下书面报告，通报全体参与{{
                          markType
                        }}人员。
                      </p>
                      <p></p>
                      <p>（1）通过{{ markType }}发现的主要问题；</p>
                      <p>（1）对{{ markType }}准备情况的评价；</p>
                      <p>（1）对预案有关程序、内容的建议和改进意见；</p>
                      <p>（1）对训练、器材设备方面的改进意见；</p>
                      <p>（1）{{ markType }}的最佳顺序和时间建议；</p>
                      <p>（1）对{{ markType }}情况设置的意见；</p>
                      <p>（1）对{{ markType }}指挥机构的意见等。</p>
                    </div> -->
                    <el-input class="mt10" type="textarea" v-model="form.exerciseSummaryPosition" style="line-height:30px" rows="10"> </el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row class="center">
                <el-col :span="16" class="mt20">
                  <h2>八、{{ markType }}照片</h2>
                </el-col>
              </el-row>

              <el-row class="center">
                <el-col :span="16">
                  <el-form-item prop="drillImage" label="上传图片(最多可上传20张)">
                    <el-col>
                      <el-upload action="#" class="uploadSmall" :http-request="upload" list-type="picture-card" :file-list="fileList" :limit="20">
                        <i slot="default" class="el-icon-plus"></i>
                        <div slot="file" slot-scope="{ file }">
                          <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                          <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                              <i class="el-icon-zoom-in"></i>
                            </span>

                            <span class="el-upload-list__item-delete" @click="handleRemove(file, 'nowImage')">
                              <i class="el-icon-delete"></i>
                            </span>
                          </span>
                        </div>
                      </el-upload>
                    </el-col>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
          </el-col>
          <!-- <el-col :span="12">
          <el-row>
            <el-form-item label-width="160px" prop="" label="巡查频次设置 ">
              <el-switch v-model="form.isTime"> </el-switch>
              &nbsp;
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-plus"
                @click="addtime"
              ></el-button>
            </el-form-item>
          </el-row>
          <div
            v-show="form.isTime"
            v-for="(item, index) in form.get_rate"
            :key="index"
          > -->
          <!-- <el-row>
              <el-form-item label-width="160px" prop="" label="巡查时间 ">
                <el-col :span="6">
                  <el-time-picker
                    v-model="item.m_start_time"
                    type="time"
                    value-format="HH:mm:ss"
                    placeholder="开始日期"
                  >
                  </el-time-picker>
                </el-col>
                <el-col :span="6" class="ml20">
                  <el-time-picker
                    v-model="item.m_end_time"
                    type="time"
                    value-format="HH:mm:ss"
                    placeholder="结束日期"
                  >
                  </el-time-picker>
                </el-col>
              </el-form-item>
            </el-row> -->
          <!-- <el-row>
              <el-form-item label-width="160px" prop="" label="巡查时间 ">
                <el-col :span="6">
                  <el-select v-model="item.m_rate">
                    <el-option :value="1">1</el-option>
                    <el-option :value="2">2</el-option>
                    <el-option :value="3">3</el-option>
                    <el-option :value="4">4</el-option>
                    <el-option :value="5">5</el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-row> -->
          <!-- </div>
        </el-col> -->
        </el-row>
      </el-form>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="60%">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!-- <div class="btn-box center" v-if="this.$route.query.type==0">
          
       <el-button type="success" class="ml20" @click="downLoad()">导出</el-button>
      <el-button type="primary" @click="$router.back()" class="ml20">返回</el-button>

      </div> -->
    <div class="btn-box center"> 
      <el-button type="primary" @click="onSubmit" :loading="btnLoading" class="ml20" v-hasPermi="['plan:drillrecord:update']" >保存</el-button>
      <el-button type="success" class="ml20" v-if="this.$route.query.id" @click="downLoad()">导出</el-button>
      <el-button type="primary" class="ml20" @click="onSubmit(1)" v-hasPermi="['plan:record:syncWordWordRecord']" :loading="btnLoading">保存并同步</el-button>
      <el-button type="primary" @click="$router.back()" class="ml20">返回</el-button>
    </div>
  </div>
</template>

<script>
// import {buildList} from './options'
// import {addCompany, editCompany} from "../../api/company";
// import {getArea} from "../../api/common";
import { getSafeList } from "../../api/safety";
import { first } from "./asset/muban";
import OSS from "ali-oss";
import transfer from "../../components/transfer";
export default {
  components: { transfer },
  inject: ["reload"],
  data() {
    return {
      id: this.$route.query.id || "",
      c_num: this.$route.query.c_num || this.$local.get("userInfo").societyuuid,
      editable: this.$route.query.type == 1 || this.$route.query.type == 3,
      groupName: "",
      markType: this.$route.query.page == 0 ? "演练" : "灭火",
      peopleAll: false,
      muban: [
        {
          title: "一、单位的基本情况",
          formName: "",
          child: [
            {
              subTitle: "单位基本情况",
              subDesc: "单位名称、地址、使用功能、建筑面积、建筑结构及主要人员等情况",
              formName: "baseJibenqk",
              value: "",
              delable: false,
            },
            {
              subTitle: "消防安全重点部位",
              subDesc: "消防控制室、消防水泵房、变配电室、厨房、空调机房、发电机房、可燃物品仓库、集体宿舍等部位",
              formName: "xiaofangZhongdian",
              value: "",
              delable: true,
            },
            {
              subTitle: "消防设施、灭火器材情况。",
              subDesc: "火灾自动报警、自动喷水灭火、防排烟、气体灭火、室内、外消火栓、灭火器等",
              formName: "xiaofangSheShi",
              value: "",
              delable: true,
            },
            {
              subTitle: "消防组织、志愿消防队人员及装备配备情况",
              subDesc: "消防管理归口部门、志愿消防队人员情况、微型消防站器材配备情况等",
              formName: "xiaofangPeibei",
              value: "",
              delable: true,
            },
          ],
          desc: "",
          delable: false,
        },
        {
          title: `二、应急组织机构${this.$route.query.page == 0 ? "演练" : "灭火"}人员及主要职责记录`,
          formName: "personRecord",
          child: [
            {
              subTitle: "火场指挥组：",
              subDesc:
                "负责现场指挥。指挥协调各职能小组和志愿消防队（微型消防站）队员开展工作，组织实施火灾扑救及人员疏散工作。待消防救援队伍到达现场后，及时向指挥员报告火场内的有关情况，按照指挥员的统一部署，协调配合消防队伍开展灭火救援行动",
              formName: "zhihuiName",
              value: "",
              delable: false,
            },
            {
              subTitle: "灭火行动组：",
              subDesc: "负责现场灭火、抢救被困人员、操作消防设施等工作。",
              formName: "miehuoName",
              value: "",
              delable: false,
            },
            {
              subTitle: "疏散引导组：",
              subDesc: "负责引导人员疏散自救，确保人员安全快速疏散至安全区域。",
              formName: "shusanName",
              value: "",
              delable: true,
            },
            {
              subTitle: "安全防护救护组：      ",
              subDesc: "负责对受伤人员进行紧急救护，并视伤情转送医疗机构",
              formName: "jiuhuName",
              value: "",
              delable: true,
            },
            {
              subTitle: "火灾现场警戒组：",
              subDesc: "负责控制各出入口，禁止无关人员进入；待火灾扑灭后保护现场。",
              formName: "jingjieName",
              value: "",
              delable: true,
            },
            {
              subTitle: "后勤保障组：",
              subDesc: "负责通信联络、车辆调配、道路畅通、供电控制、水源保障。",
              formName: "baozhangName",
              value: "",
              delable: true,
            },
            {
              subTitle: "通信联络组：      ",
              subDesc: "负责操作消防自动控制系统，并与指挥机构和当地消防部门、区域联防单位及其他应急行动涉及人员的通信、联络。",
              formName: "lianluoName",
              value: "",
              delable: true,
            },
            {
              subTitle: "机动组：",
              subDesc: "接受火场指挥组的指挥，负责增援行动。",
              formName: "jidongName",
              value: "",
              delable: true,
            },
          ],
          desc: "",
          delable: false,
        },
        {
          title: `三、火灾情况记录`,
          formName: "",
          child: [
            {
              subTitle: "起火时间段:",
              subDesc: "",
              formName: "fireTime",
              value: "",
              delable: false,
            },
            {
              subTitle: "起火位置：",
              subDesc: "",
              formName: "fireLocation",
              value: "",
              delable: false,
            },
            {
              subTitle: "起火物品：",
              subDesc: "",
              formName: "fireThing",
              value: "",
              delable: true,
            },
            {
              subTitle: "燃烧范围及火势蔓延情况：",
              subDesc: "",
              formName: "qihuoFangxiang",
              value: "",
              delable: true,
            },
            {
              subTitle: "消防安全重点部位：",
              subDesc: "",
              formName: "zhuyhaoQihuo",
              value: "",
              delable: true,
            },
            {
              subTitle: "火灾造成的危害和影响：",
              subDesc: "",
              formName: "weihaiHouguo",
              value: "",
              delable: true,
            },
          ],
          desc: "",
          delable: false,
        },
      ],
      mubancopy: [],
      groupList: [], // 所有组别
      peopleList: [], // 所有人员
      selectPeopleList: [], // 带选择的人员
      selectedPeople: [], // 已选择的人员
      filterMethod(query, item) {
        return item.label.indexOf(query) > -1;
      },
      compOption: [], // 人员库
      selectGroup: "",
      btnLoading: false,
      selectIndex: 1,
      units: [],
      select2: [],
      nowImage: [],
      nowImage1: [],
      dialogVisible: false,
      dialogImageUrl: "", // 预览图片url
      personParmms: {
        tower: "",
        tier: "",
      },
      form: {
        year: "",
        month: "",
        day: "",
        time: "",
        drillName: "",
        baseJibenqk: "",
        xiaofangZhongdian: "",
        xiaofangSheShi: "",
        xiaofangPeibei: "",
        fireTime: "",
        fireLocation: "",
        fireThing: "",
        // fireScope: "",

        // firePart: "",
        // fireInfluences: "",
        qihuoFangxiang: "",
        zhuyhaoQihuo: "",
        weihaiHouguo: "",
        exerciseSummaryPosition: "",
        exerciseSummaryName: "",
        drillImage: "",
        miehuoImage: "",
        personRecord: {
          zhihuiName: "",
          miehuoName: "",
          shusanName: "",
          jiuhuName: "",
          jingjieName: "",
          baozhangName: "",
          lianluoName: "",
          jidongName: "",
        },
        alarmRecord: "", // 火灾报警接警处置记录
        fireRecord: {
          name9: "",
          name10: "",
          miehuoName1: "",
          minute: "",
          hour1: "",
          minute1: "",
          shusanName1: "",
          hour2: "",
          minute2: "",
          jiuhuName1: "",
          jingjieName1: "",
          lianluoName1: "",
        },
      },
      rules: {},
      fileList: [],
      fileList1: [],
    };
  },
  computed: {},
  async created() {
    await this.$post("drill/grouplist", { c_company_num: this.c_num }).then((res) => {
      this.groupList = res.data;
      this.groupList.map((item) => {
        item.selectAll = false;
      });
    });
    await this.$post("/drill/companynumdrillrenyuanall", {
      c_company_num: this.c_num,
    }).then((res) => {
      for (var i in this.peopleList.quanbu) {
        this.form.person[i] = [];
      }
    });
    await this.$post("/drill/towetinfo", { c_company_num: this.c_num }).then((res) => {
      this.units = res.data.list;
    });
    if (this.$route.query.id) {
      this.getList();
    }
  },
  mounted() {},

  methods: {
    getPersonAll() {
      this.personParmms.company_num = this.c_num;
      this.personParmms.tower = this.form.drill_tower;
      this.personParmms.tier = this.form.drill_tier;
      console.log(this.personParmms);
      this.$post("/drill/filterByPartition", this.personParmms).then((res) => {
        this.selectPeopleList = res.data;
        var arr = [];
        this.selectPeopleList.map((item) => {
          var obj = { label: item.name, key: item.uuid };
          arr.push(obj);
        });
        this.compOption = arr;

        // this.getPeople(1, 0);
      });
    },
    handleAll(val) {
      this.groupList.map((item, index) => {
        item.selectAll = val;
        this.personAll(val, item, index);
      });
    },
    up1(val) {
      console.log(val,'shusantu')
      this.upload(val, 1);

      return;
    },
    changetower(val, istr) {
      if (istr) {
        this.form.drill_tier = "";
      }
      this.units.map((item, index) => {
        if (item.dueng === val) {
          this.select2 = item.ceng;
        }
      });
      this.getPersonAll();
    },
    changetier(val) {
      this.getPersonAll();
    },
    downLoad() {
      // var url = 'http://192.168.0.108:8881'
      // var url = "https://tr.tongren119.com"
      window.open(`${this.$config.apiUrl}/drill/exportWordRecord?uuid=${this.$route.query.id}`);
    },
    getPeople(val, index) {
      if (val) {
        this.selectIndex = index;
        this.selectGroup = this.$map.planGroup[val];
        this.groupName = this.groupList[index].zuzhi_name;
      }
      // this.selectPeopleList = this.peopleList.quanbu[this.selectGroup];
      console.log(this.selectPeopleList);

      this.selectedPeople = this.form.person[this.selectGroup];
      console.log(this.selectedPeople);
    },
    // 单个人员选择
    itemchange(val, load) {
      if (!load) {
        this.form.person[this.selectGroup] = this.selectedPeople;
      } else {
        this.selectedPeople = this.form.person[this.selectGroup];
      }

      var item = null;
      item = this.groupList[this.selectIndex];
      if (this.form.person[this.selectGroup].length && this.form.person[this.selectGroup].length >= this.selectPeopleList.length) {
        item.selectAll = true;
      } else {
        item.selectAll = false;
      }
      this.groupList.splice(this.selectIndex, item);
    },
    // 整组选择
    personAll(val, it, index) {
      this.getPeople(it.zuzhi_xuhao, index);

      this.groupList.splice(index, it);
      this.selectAllGroup(val);
    },
    selectAllGroup(val) {
      var arr = [];
      if (val) {
        this.selectPeopleList.map((item) => {
          arr.push(item.uuid);
        });
      }
      this.form.person[this.selectGroup] = arr;
      this.selectedPeople = arr;
      this.form.person[this.selectGroup];
    },
    selectgroup(it, index) {
      this.getPeople(it.zuzhi_xuhao, index);
    },
    handlePictureCardPreview(file) {
      console.log(file,'fle')
      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
    },
    upload(val, type) {
      console.log(val,type,'val, type')
      let client = new OSS(this.$bus.config.ossConfig);
      let file = val.file;
      let _this = this;
      let id = this.$bus.config.plan + "/t" + Date.now() + "s" + file.size + "/" + file.name;
      this.$set(this.fileList, id, {
        name: file.name,
        size: file.size,
        uploading: true,
        time: 0,
        progress: 0,
        key: id,
        client: client,
      });
      // _this.getTimes(file, id)

      // 定义上传方法。
      function multipartUpload() {
        _this.fileList[id].client
          .multipartUpload(id, file, {
            checkpoint: _this.fileList[id] ? _this.fileList[id].data : null,
            progress: (p, checkpoint, res) => {
              //log(p,checkpoint,res)
              if (checkpoint) {
                _this.fileList[id].progress = p * 100;
                _this.fileList[id].data = checkpoint;
              }
            },
            partSize: 1000 * 1024, //设置分片大小
            timeout: 120000, //设置超时时间
            mime: val.type,
          })
          .then((res) => {
            _this.fileList[id].progress = 100;
            _this.fileList[id].uploading = false;

            // _this.form.image_name = `http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`

            if (!type) {
              _this.fileList.push({
                name: _this.fileList[id].name,
                url: `http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`,
                // 海大
              });
              _this.nowImage.push(`http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`);
            } else {
              _this.fileList1.push({
                name: _this.fileList[id].name,
                url: `http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`,
              });
              _this.nowImage1.push(`http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`);
            }
            _this.$notify({
              title: "上传成功",
              message: `${_this.fileList[id].name}上传完成`,
              type: "success",
            });
            // var stobj = {tr_task_id:_this.uuid,tr_baogao_address,tr_sub_status:1,tr_shengcheng_status:1,tr_baogao_xingshi:0}
            // _this.$post('/api-b/tr/plan/baogaoaddress',stobj).then(data=>{

            //     _this.getList()
            // })
          })
          .catch((err) => {
            if (err.code == "RequestError" || err.code == "ConnectionTimeoutError") {
              //网络错误或超时
              setTimeout(multipartUpload, 3000);
            }
          });
      }

      multipartUpload();
    },
    delItem(index, ind) {
      this.$confirm("此操作将永久删除该选项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var Name = this.muban[index].child[ind].formName;

          this.muban[index].formName ? (this.form[this.muban[index].formName][Name] = "personRecordDeleteFlag") : (this.form[Name] = "personRecordDeleteFlag");
          console.log(this.form);
          this.muban[index].child.splice(ind, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {});
    },
    handleRemove(file, type) {
      var fileList = [];

      var nowImage = [];
      if (type == "nowImage") {
        fileList = this.fileList;
        nowImage = this.nowImage;
      } else {
        fileList = this.fileList1;
        nowImage = this.nowImage1;
      }
      fileList.map((item, index) => {
        if (item.uid == file.uid) {
          fileList.splice(index, 1);
          nowImage.splice(nowImage.indexOf(item.url), 1);
        }
      });
    },
    // handleRemove1(file,type) {
    //   console.log(type)
    //   return
    //   this.fileList.map((item, index) => {
    //     if (item.uid == file.uid) {
    //       this.fileList.splice(index, 1);
    //       this.nowImage1.splice(this.nowImage.indexOf(item.url), 1);
    //     }
    //   });
    // },
    save() {
      const loading = this.$loading({
        lock: true,
        text: "上传中，请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var url = "/drill/drillInsertRecord";

      // for(var i in this.form){
      //   if(this.form[i]==null){
      //     this.form[i]=''
      //   }
      // }
      this.$post(url, this.form)
        .then((res) => {
          loading.close()
          this.$message({message: res.msg,type: "success", duration: 700,});
          this.$router.back();
          // this.reload()
          // this.getList()
          this.muban = first;

          this.btnLoading = false;
        })
        .catch((err) => {
          this.btnLoading = false;
        });
    },
    saveExport() {
      const loading = this.$loading({
        lock: true,
        text: "上传中，请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$post("/drill/syncWordWordRecord", this.form)
        .then((res) => {
          loading.close()
          this.$message({message: res.msg,type: "success", duration: 700,});
          this.$router.back();

          this.btnLoading = false;
          // this.reload();
        })
        .catch((err) => {
          this.btnLoading = false;
        });
    },
    onSubmit(exprot) {
      this.btnLoading = true;
      console.log(this.nowImage);
      this.form.miehuoImage = this.nowImage.join(",");
      this.form.drillImage = this.nowImage1.join(",");
      console.log(this.form);
      // return

      // this.form.drill_status = this.$route.query.type == 3 ? "2" : "";
      // this.form.get_item = this.CheckedKeys;
      if (exprot == 1) {
        this.saveExport();
      } else {
        this.save();
      }
      //    this.$refs.form.validate((valid) => {
      //   if (valid) {
      //     this.save();
      //   } else {
      //     this.nowIndex = 0;
      //     return false;
      //   }
      // });

      // this.$refs.form.validate((valid) => {
      //               if (valid) {
      //               } else {
      //                   console.log('error submit!!');
      //                   return false;
      //               }
      //           });
    },

    addtime() {
      if (this.form.get_rate.length < 2) {
        this.form.get_rate.push({
          m_start_time: "",
          m_end_time: "",
          m_rate: "",
        });
      } else {
        this.form.get_rate.splice(1);
      }
    },
    getList() {
      this.$post(`/drill/drillInfoRecord`, {
        drill_uuid: this.$route.query.id,
      }).then((res) => {
        console.log(res);
        res.data.drill_summary = 1;
        this.nowImage1 = res.data.drillImage ? res.data.drillImage.split(",") : [];
        this.nowImage = res.data.miehuoImage ? res.data.miehuoImage.split(",") : [];

        this.nowImage.map((item, index) => {
          this.fileList.push({ name: "图片" + index, url: item });
        });
        this.nowImage1.map((item, index) => {
          this.fileList1.push({ name: "图片" + index, url: item });
        });
        this.$set(this, "form", res.data);
        console.log(this.form);
        this.form.alarmRecord = this.form.alarmRecord.replace(/\\n/g, "\n");
        this.form.fireRecord = this.form.fireRecord.replace(/\\n/g, "\n");

        this.form.exerciseSummaryPosition = this.form.exerciseSummaryPosition.replace(/\\n/g, "\n");

        var spliceList = [];
        this.muban.map((item, index) => {
          if (item.child) {
            item.child.map((it, ind) => {
              if (item.formName) {
                if (this.form[item.formName][it.formName] == "personRecordDeleteFlag") {
                  spliceList.push({ father: item.formName, son: it.formName });
                  // this.form[item.formName][it.formName] = "";
                }
              } else {
                if (this.form[it.formName] == "personRecordDeleteFlag") {
                  spliceList.push({ father: "", son: it.formName });
                  // this.form[it.formName] = "";
                }
              }
            });
          }
        });

        spliceList.map((item, index) => {
          this.muban.map((it) => {
            if (it.formName === item.father) {
              it.child.map((i, ind) => {
                if (i.formName === item.son) {
                  it.child.splice(ind, 1);
                }
              });
            }
          });
        });
        console.log(this.form);

        console.log(spliceList);
      });
    },
    //树的数组
  },
};
</script>

<style scoped lang="scss">
.uploadSmall {
}
::v-deep .el-textarea__inner {
  display: block;
  resize: vertical;
  padding: 5px 15px;
  line-height: 2.3;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: #606266;
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
::v-deep .el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 148px !important;
  /* height: 148px; */
  /* cursor: pointer; */
  line-height: 146px;
  vertical-align: top;
}
.container-list {
  padding: 0 20px;
}
.tree {
  font-size: 18px;
}
.duty {
  padding: 10px;
  border: 1px solid #999;
  p {
    margin-top: 10px;
  }
}
.inputSmall {
  width: 80px;
  display: inline-block;
}
.inputBig {
  max-width: 500px;
  display: inline-block;
}
.perbutton {
  width: 120px;
}
</style>
